module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dVcxk"))).then(() => parcelRequire('d0iPb'));